import Swiper, { Autoplay, Navigation } from 'swiper';

document.addEventListener('DOMContentLoaded',function () {
    const homeSlider = new Swiper('#home-slider', {
        modules: [Autoplay, Navigation],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        speed: 3000,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
    });
})
